// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  width: 100%;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-inline: 14px;
  background: var(--color-background-alt);
  border-bottom: 1px solid #272727;
}
.header .type-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}
.header .type-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.header .type-block .button-type {
  min-width: 88px;
  min-height: 30px;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-black);
  background: transparent;
  border-radius: 26px;
  text-transform: uppercase;
  font-family: AppFontMedium, sans-serif;
  background: #ebdfda;
}
.header .type-block .button-type.selected {
  background: var(--ion-color-primary);
  color: white !important;
}
.header .title {
  width: 100%;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 8%;
  text-align: center;
  text-transform: uppercase;
  padding-bottom: 10px;
  border-bottom: 1px solid #B5B5B5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/header/header.component.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,aAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EAEA,uCAAA;EACA,gCAAA;AAHD;AAMC;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAJF;AAOC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AALF;AAOE;EACC,eAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACC,uBAAA;EACA,mBAAA;EACD,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sCAAA;EACA,mBAAA;AALH;AAMG;EACC,oCAAA;EACA,uBAAA;AAJJ;AASC;EACC,WAAA;EAEA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,oBAAA;EACA,gCAAA;AATF","sourcesContent":["@import '../../../theme/mixins';\n\n.header {\n\twidth: 100%;\n\theight: 140px;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding-inline: 14px;\n\n\tbackground: var(--color-background-alt);\n\tborder-bottom: 1px solid #272727;\n\n\n\t.type-row {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 18px;\n\t}\n\n\t.type-block {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 5px;\n\n\t\t.button-type {\n\t\t\tmin-width: 88px;\n\t\t\tmin-height: 30px;\n\t\t\tfont-size: 10px;\n\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\tcolor: var(--color-black);\n\t\t\tbackground: transparent;\n\t\t\tborder-radius: 26px;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-family: AppFontMedium, sans-serif;\n\t\t\tbackground: #ebdfda;\n\t\t\t&.selected {\n\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\tcolor: white !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t.title {\n\t\twidth: 100%;\n\n\t\tfont-size: 10px;\n\t\tline-height: 12px;\n\t\tletter-spacing: 8%;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\n\t\tpadding-bottom: 10px;\n\t\tborder-bottom: 1px solid #B5B5B5;\n\t}\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
